import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export function PreviewCardSkeleton() {
  return (
    <Card className="overflow-hidden h-full flex flex-col py-0">
      <CardHeader className="p-0">
        <div className="aspect-video w-full">
          <Skeleton className="h-full w-full rounded-none" />
        </div>
      </CardHeader>
      <CardContent className="px-4 flex-1">
        <Skeleton className="h-6 w-3/4 mb-2" />
        <Skeleton className="h-4 w-1/2 " />
      </CardContent>
      <CardFooter className="p-4 ">
        <Skeleton className="h-10 w-full rounded-md" />
      </CardFooter>
    </Card>
  )
}
